"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRedirect = void 0;
var route_1 = require("./route");
Object.defineProperty(exports, "sanitizeRedirect", { enumerable: true, get: function () { return route_1.sanitizeRedirect; } });
//# sourceMappingURL=index.js.map